import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { ArrowRight } from 'lucide-react';
import { useI18n } from '@/lib/i18n';
import { Button } from '@/components/ui/button';

const DJANGO_BASE_URL = 'https://agritrack.samperlabs.com';

export const CTA = () => {
  const { t } = useI18n();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      ref={ref}
      className="relative py-24 lg:py-32 overflow-hidden"
      data-testid="cta-section"
    >
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary to-primary-light" />
      
      {/* Noise overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
      }} />

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-white tracking-tight leading-tight mb-6"
            data-testid="cta-title"
          >
            {t('cta.title')}
          </h2>
          <p
            className="text-lg lg:text-xl text-forest-300 max-w-2xl mx-auto mb-10"
            data-testid="cta-subtitle"
          >
            {t('cta.subtitle')}
          </p>

          <a href={`${DJANGO_BASE_URL}/register/`} data-testid="cta-button">
            <Button
              size="lg"
              className="bg-white text-primary font-bold px-10 py-6 text-lg rounded-xl shadow-elevated hover:bg-forest-50 hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
            >
              {t('cta.button')}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </a>

          <p className="mt-6 text-forest-400 text-sm font-medium">
            {t('cta.noCard')}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
